import { downloadBlob } from './download-file.utils';

/** Eén bestand in een zip; het pad mag mappen bevatten (`attachments/foto.jpg`). */
export interface ZipEntry {
  readonly path: string;
  readonly content: string | Uint8Array;
}

/**
 * Bouwt een zip in de browser. JSZip wordt pas hier (lui) geladen, zoals ExcelJS bij de
 * ephemeris-export: het zit dus niet in de gewone bundel van de app.
 */
export async function buildZip(entries: readonly ZipEntry[]): Promise<Blob> {
  const module = await import('jszip');
  // CommonJS-pakket: afhankelijk van de bundler zit de constructor onder `default` of op het module-object.
  const JSZip = ((module as unknown as { default?: typeof module.default }).default ?? module) as typeof module.default;
  const zip = new JSZip();
  for (const entry of entries) {
    zip.file(entry.path, entry.content);
  }
  return zip.generateAsync({ type: 'blob', compression: 'DEFLATE', mimeType: 'application/zip' });
}

/** Bouwt een zip en laat de browser hem downloaden. */
export async function downloadZip(entries: readonly ZipEntry[], fileName: string): Promise<void> {
  downloadBlob(await buildZip(entries), fileName);
}
